import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        red: {
            color: theme.palette.common.red,
        },
        yellow: {
            color: theme.palette.common.yellow,
        },
        green: {
            color: theme.palette.common.green,
        },
    }
})

export default useStyles
